app
    .controller('OrderSelectCtrl', function ($http, $scope) {

        this.cancel = () => {
            this.dismiss();
        };

        this.isSelected = (order) => {
            return this.selectedOrder && order && this.selectedOrder.id === order.id;
        };

        this.onSelect = (order) => {
            this.selectedOrder = order;
        };

        this.check = () => {

        };

        this.confirm = () => {
            this.close({$value: {client: this.resolve.client, order:this.selectedOrder}});
        };

        this.$onInit = () => {
        };

        $scope.formatDate = function(date){
            var dateOut = new Date(date);
            return dateOut;
        };
    })
    .component('orderSelect', {
        template: `
        <div class="px-4 py-2" style="width: 100%; min-width: 32vw;">
            <div class="header p-1" style="border-bottom: 1px solid #1D1D1B">
                <h1 style="font-size: 24px; font-family: 'goboldregular', Impact, sans-serif;margin: 10px auto; text-align: center;">
                    ASSIGN TO
                </h1>
            </div>
            <style>
                .isSelected{
                   background-color: #63A09D;
                }
            </style>
            <div class="body" style="max-height: 400px; overflow-y: scroll;overflow-x: hidden;">
                <div class="row justify-content-center pb-2 mx-0 my-4">
                    <div class="col-4 text-right">
                        <img style="width:40px;" 
                            ng-src="{{ $ctrl.resolve.client.picture? $ctrl.resolve.client.picture : '/upload/' + $ctrl.resolve.client.defaultPicture }}"/>
                    </div>
                    <div class="col-5 text-left" style="font-size: 16px;vertical-align: middle;line-height: 42px;font-weight: bold;">
                        {{ $ctrl.resolve.client.displayName }}
                    </div>
                </div>
                <div class="text-bold text-uppercase text-left my-2" style="font-family: 'goboldregular', Impact, sans-serif;font-size:16px;">{{ 'modal.orderSelect.title' | translate }}</div>
                <div ng-if="!$ctrl.resolve.orders.length" style="height: 20vh; display: flex; justify-content: center; align-items: center;">
                    <i class="fa fa-spinner fa-spin" ng-if="$ctrl.loading"></i>
                    <div ng-if="!$ctrl.loading">
                        <p>{{ 'modal.orderSelect.notFound' | translate }}</p>
                    </div>

                </div>
                <div ng-if="!$ctrl.loading && $ctrl.resolve.orders" class="pt-0" style="padding: 1rem 0; margin: .5rem; border-radius: 5px;">
                    <div class="row" ng-repeat="order in $ctrl.resolve.orders" ng-click="$ctrl.onSelect(order)" style="padding: .5rem;" ng-class="{'isSelected': $ctrl.isSelected(order)}">
                        <div class="col-2 text-center mt-3">
                            <i class="fa fa-check-square-o fa-2x" aria-hidden="true" ng-if="$ctrl.isSelected(order)"></i>
                            <i class="fa fa-square-o fa-2x" aria-hidden="true" ng-if="!$ctrl.isSelected(order)"></i>
                        </div>
                        <div class="col-7">
                            <span>{{order.title}}</span>
                            <div>ORDER: {{ formatDate(order.creationDate['date'])|date:'MMM d, yyyy' }}</div>
                        </div>
                        <div class="col-3 text-center"><span class="text-bold font-go-bold" style="font-size:18px;">{{order.price}} $<span><br>{{order.currency}}</div>
                    </div>
                </div>
            </div>
            <div class="footer text-center mb-2">
                <button class="btn btn-green font-go-bold btn-200 mt-2 mb-4" style="font-size:16px" ng-click="$ctrl.confirm()" ng-disabled="!$ctrl.selectedOrder">
                    {{ 'modal.orderSelect.confirm' | translate }}
                </button>
                <br>
                <a class="text-dark text-bold text-underline" href="javascript:void(0);" ng-click="$ctrl.cancel()">{{ 'modal.orderSelect.cancel' | translate }}</a>
            </div>
        </div>
        `,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: 'OrderSelectCtrl'
    });
